// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1_L-T","buttons":"RemoveExpirationActionButtons_buttons__xgH-5"};